import * as React from 'react'
import { LogPointStates } from '../../../util/LogPointsService'
import { filterConfiguration, LogPointCategory, LogPointType } from '../../../util/LoggingPolicyConfigurations'
import Checkbox from '@mulesoft/anypoint-components/lib/Checkbox'
import './LogPointsSidebarItem.css'

export type ValueProps = {
  category: LogPointCategory
  selectedCategory: LogPointCategory
  selectedType: LogPointType
  state: LogPointStates
  type: LogPointType
}

export type EventProps = {
  onClick: (type: LogPointType, category: LogPointCategory) => void
  onToggleAll: (toggleNewVal: boolean) => void
}

export type Props = ValueProps & EventProps

export const LogPointsSidebarItem = (props: Props) => {
  const {type, category, selectedType, selectedCategory, state, onToggleAll} = props
  const onClick = () => props.onClick(type, category)
  const selected = selectedType === type && selectedCategory === category
  const baseClassName = 'log-points-sidebar-item'
  const selectedClassName = selected ? `${baseClassName} log-points-sidebar-item-selected` : baseClassName

  const keys = Object.keys(props.state).filter(filterConfiguration(state, category, type))
  const shouldEnableAll = keys.find(key => !state[key].enabled) === undefined
  const shouldEnableNone = keys.find(key => state[key].enabled) === undefined
  const shouldEnableIndeterminate = !shouldEnableAll && !shouldEnableNone
  const onChange = () => onToggleAll(!shouldEnableAll)

  return (
    <div className={selectedClassName} onClick={onClick} data-test-id={`${type}-${category}-item`}>
      <Checkbox
        testId={`${type}-${category}-checkbox`}
        indeterminate={shouldEnableIndeterminate}
        checked={shouldEnableAll}
        onChange={onChange}
      />
      <span data-test-id={`${type}-${category}-label`}>{props.category}</span>
    </div>
  )
}
